'use client';

import * as React from 'react';
import LayoutOverlay from '@/components/ui/LayoutOverlay';
import Overlay from '@/components/ui/Overlay';
import { useOverlay } from '@/components/hooks/useOverlay';
import { IHeaderProps } from '@/components/ui/Header';
import Button from '@/components/ui/Button';
import Block from '@/components/ui/Block';
import Buttons from '@/components/ui/Buttons';
import MobileMenuLinks from '@/components/ui/MobileMenuLinks';
import { isAuthenticated } from '@/lib/helper/is-authenticated';
import { CmsParams } from '@/lib/cms-params.type';
import { doLogout } from '@/lib/actions/logout.action';
import { useQueryClient } from '@tanstack/react-query';
import MobileMenuCurrencies from '@/components/ui/MobileMenuCurrencies';
import { CurrencySelector } from '@/components/currency-selector/currency-selector';

const OverlayMobileMenu: React.FunctionComponent<{
  links: IHeaderProps['links'];
  cmsParams: CmsParams;
}> = (props) => {
  const { closeOverlay, isOverlayOpen } = useOverlay('mobile-menu');
  const authenticated = isAuthenticated(props.cmsParams);
  const client = useQueryClient();

  const handleLogout = async () => {
    try {
      await doLogout();
      client.clear();
      window.location.assign(window.location.origin);
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <Overlay
      isOpen={isOverlayOpen}
      onClose={closeOverlay}
      layout="mobile-menu"
      hideClose={true}
    >
      <LayoutOverlay size="mobile-menu">
        <Block>
          <Buttons>
            <Button
              iconLeft="close"
              onClick={closeOverlay}
              theme="discrete"
            />
          </Buttons>
          {authenticated && (
            <MobileMenuCurrencies>
              <CurrencySelector
                cmsParams={props.cmsParams}
                ns={'default'}
              />
            </MobileMenuCurrencies>
          )}
          <MobileMenuLinks links={props.links} />
        </Block>
        {authenticated && (
          <Block>
            <Button
              title="Sign Out"
              theme="link"
              onClick={() => {
                closeOverlay();
                void handleLogout();
              }}
            />
          </Block>
        )}
      </LayoutOverlay>
    </Overlay>
  );
};

OverlayMobileMenu.displayName = 'OverlayMobileMenu';

export default OverlayMobileMenu;
